import React, { useState } from 'react';
import moment from 'moment';

const LeaveRecDetail = ({ leaveRec,toggleFunc, isShow, onEdit, onCancel, canEdit = false, canCancel = false }) => {

  const {
    statusString,
    sDate,
    eDate,
    leaveTypeName,
    reasons,
    fileName,
    notes,
    leaveHours
    } = leaveRec;

  const statusColorMap = {
    核准: '#2e7d32',
    作廢: '#c62828',
    送出: '#ef6c00',
    新增: '#1565c0'
  };

  const leaveTypeColorMap = {
    補休: '#1565c0',
    特休: '#2e7d32'
  };

  const statusColor = statusColorMap[statusString] || 'inherit';
  const leaveTypeColor = leaveTypeColorMap[leaveTypeName] || 'inherit';
  const badgeBaseStyle = {
    color: '#fff',
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: '999px',
    display: 'inline-block',
    lineHeight: 1.4
  };


  return (
    <div className="u-editblock fadeIn" style={{display: isShow === true ? 'flex' : 'none'}}  onClick={
      (e) => {
        e.preventDefault();
        toggleFunc();
      }
    }>
      <div className="form-block" style={{width:'400px',maxWidth:'100%'}}>
        <div className="u-small-title">請假單</div>
        <form className="u-form">
        <div className="row">
            <div className="col-6 col-pad-12">
              <label className="u-form__label text-align-right">假單狀態：<span style={{ ...badgeBaseStyle, backgroundColor: statusColor }}>{statusString}</span></label>
            </div>
            <div className="col-6 col-pad-12">
              <label className="u-form__label text-align-right">假別：<span style={{ ...badgeBaseStyle, backgroundColor: leaveTypeColor }}>{leaveTypeName}</span></label>
            </div>
          </div>
          <div className="row">
            <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right">自{moment(sDate).format('HH:mm')}起至{moment(eDate).format('HH:mm')}</label>
            </div>
              <div className="col-6 col-pad-12">
            <label className="u-form__label text-align-right">請假時數：{leaveHours} 小時</label>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-pad-12">
            <label className="u-form__label text-align-right">事由：</label><textarea rows="3" cols="30" readOnly style={{marginTop:'8px', border:'none'}} value={reasons || ''}></textarea>
            </div>

          </div>
          <div className="row">
            <div className="col-12 col-pad-12">
            <label className="u-form__label text-align-right">備註：{notes}</label>
            </div>
          </div>
          {
              fileName ?
              <div className="row">
                <div className="col-12 col-pad-12">
                    <label className="u-form__label text-align-right">附件：</label>
                    <img style={{width:'500px', maxWidth:'90%'}} onClick={
                      (e) => {
                        e.preventDefault();
                        window.open(fileName);
                      }
                    } src={fileName}/>
                </div>
              </div>
            :''
          }

          {
            canEdit ?
            <div className="row">
              <div className="col-12 col-pad-12">
                <div style={{ color: '#c62828', fontWeight: 700, marginTop: '8px' }}>
                  警示：編輯後將強制把假單狀態改為「核准」，並同步進行對應的時數修正。
                </div>
              </div>
            </div>
            : ''
          }

          <div className="u-btn-group right">
            {
              canEdit && typeof onEdit === 'function' ?
              <button className="btn btn-md save" onClick={
                (e) => {
                  e.preventDefault();
                  onEdit(leaveRec);
                }
              }>編輯</button>
              : ''
            }
            {
              canCancel && typeof onCancel === 'function' ?
              <button className="btn btn-md delete m-l-16" onClick={
                (e) => {
                  e.preventDefault();
                  onCancel(leaveRec);
                }
              }>作廢</button>
              : ''
            }
            <button className="btn btn-md cancel m-l-16" onClick={
              (e) => {
                e.preventDefault();
                toggleFunc();
              }
            }>關閉</button>
          </div>
        </form>
      </div>
    </div>
  )

}

export default LeaveRecDetail;